import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import _throttle from 'lodash/throttle'


// modules
import appState from './appState'
import transientState from './transientState'
import coreState from './coreState'
import videoDevicesState from './videoDevicesState'

export const KEY_PERSISTENT_LOCAL_STORAGE = 'org.gurgur.epcqrcode.v1'

const vuexLocal = new VuexPersistence({
	storage: window.localStorage,
	key: KEY_PERSISTENT_LOCAL_STORAGE,
	modules: [ 'appState', 'coreState', 'videoDevicesState' ],
	saveState: _throttle((key, state, storage) => {
		if(state && state.transientState && state.transientState.restoreFactorySettings) return
		storage.setItem(key, JSON.stringify(state))

	}, 800)
})

const plugins = [ vuexLocal.plugin ]

Vue.use(Vuex)
const store = new Vuex.Store({
	
	modules:{
		appState, 
		coreState,
		videoDevicesState,
		transientState
	},
	actions: {
		test: (ctx) => console.log('ROOT - action')
	},
	plugins
})

export default store